import Bookmarks from '../lib/bookmarks';
import Dialog from '../lib/dialog';
import Feature from '../lib/feature';
import UiInteraction from '../lib/ui_interaction';

export default class BookmarksView {
	/**
	 * Render the main content of the bookmarks view
	 */
	content() {
		let out = document.createElement('div');

		const h1 = document.createElement('h1');
		h1.classList.add('uw-dialog-label');
		h1.setAttribute('slot', 'label');
		h1.innerText = 'My places';
		out.append(h1);
		const dialogBody = document.createElement('div');
		dialogBody.classList.add('dialog-body');

		if (Bookmarks.any()) {
			const ul = document.createElement('ul');
			ul.classList.add('bookmarks_list');

			Object.entries(Bookmarks.all()).forEach((bookmark) => {
				const li = document.createElement('li');

				// Build the delete link
				const delete_button = document.createElement('button');
				delete_button.setAttribute('type', 'button');
				delete_button.setAttribute('data-key', bookmark[0]);
				delete_button.classList.add('bookmark-delete');
				delete_button.setAttribute('aria-label', 'Delete saved place for ' + bookmark[1]);
				delete_button.innerHTML =
					'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm97.9-320l-17 17-47 47 47 47 17 17L320 353.9l-17-17-47-47-47 47-17 17L158.1 320l17-17 47-47-47-47-17-17L192 158.1l17 17 47 47 47-47 17-17L353.9 192z"/></svg>';

				const show_button = document.createElement('button');
				show_button.setAttribute('type', 'button');
				show_button.setAttribute('data-key', bookmark[0]);
				show_button.classList.add('bookmark-show');
				show_button.setAttribute('aria-label', 'Show on map: ' + bookmark[1]);
				show_button.innerHTML = bookmark[1];

				const spacer = document.createElement('span');
				spacer.innerText = '\u00a0';
				// Append our creations
				li.append(delete_button);
				li.append(spacer);
				li.append(show_button);

				// Append the li to the main <ul>
				ul.append(li);
			});
			dialogBody.append(ul);
			const p = document.createElement('p');
			p.setAttribute('style', 'font-size: 1rem; line-height: 1.4; font-style: italic;');
			p.innerText =
				'Bus stops saved prior to December 15, 2024 will need to be deleted and resaved because of a change in data format.';
			dialogBody.append(p);
			out.append(dialogBody);
		} else {
			dialogBody.innerHTML = this.emptyMessage();
			out.append(dialogBody);
		}
		return out.innerHTML;
	}

	footer() {
		return false;
	}

	emptyMessage() {
		return '<p class="no-saved-places">You don\u2019t have any saved places. Save a place (building, bus stop, parking lot) by clicking the <svg role="img" aria-label="bookmark icon" class="bookmark-on" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1201 1004l306-297-422-62-189-382-189 382-422 62 306 297-73 421 378-199 377 199zm527-357q0 22-26 48l-363 354 86 500q1 7 1 20 0 50-41 50-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"/></svg> icon in an object\u2019s details screen.</p>';
	}

	load() {
		Dialog.loadContent(this.content()).then((dialog) => {
			dialog.setAttribute('aria-labelledby', 'dialog-label');
			dialog.classList.add('dialog-bookmarks');

			// Live region for announcing bookmark deletions to screen readers
			let liveRegion = dialog.querySelector('.bookmarks-live-region');
			if (!liveRegion) {
				liveRegion = document.createElement('div');
				liveRegion.classList.add('bookmarks-live-region', 'uw-sr-only');
				liveRegion.setAttribute('aria-live', 'polite');
				dialog.appendChild(liveRegion);
			}

			const delete_buttons = dialog.querySelectorAll('.bookmark-delete');
			delete_buttons.forEach((delete_button) => {
				delete_button.addEventListener('click', () => {
					const name = delete_button.closest('li').querySelector('.bookmark-show').textContent;
					Bookmarks.remove(delete_button.dataset.key);
					delete_button.closest('li').remove();
					liveRegion.textContent = name + ' removed from saved places';
					if (!Bookmarks.any()) {
						const dialogBody = document.querySelector('.dialog-body');
						dialogBody.innerHTML = this.emptyMessage();
					}
				});
			});

			const show_buttons = dialog.querySelectorAll('.bookmark-show');
			show_buttons.forEach((show_button) => {
				show_button.addEventListener('click', () => {
					let key = show_button.dataset.key;
					// is this a post-GTFS migration key?
					if (key.startsWith('GBus')) {
						key = key.substr(1);
					}
					const feature = Feature.fromKey(key);
					UiInteraction.clearAllPopups();
					UiInteraction.fetchAndAddFeature(feature);

					// if this is a bus stop, also open its realtime arrivals
					if (key.startsWith('Bus')) {
						setTimeout(() => {
							document.querySelector('.more_button').click();
						}, 250);
					}
					Dialog.close();
				});
			});

			dialog.classList.add('dialog-help');
			dialog.classList.add('fixed-height');
		});
	}
}
